import { TextField } from '@material-ui/core';
import React, { FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';
import moment from 'moment';

interface ICampoFechaCreacionProps {
    valor: string;
}

const CampoFechaCreacion: FunctionComponent<ICampoFechaCreacionProps> = ({  valor }) => (
    <TextField
        disabled={true}
        fullWidth
        label={<Texto id="Auditoria.FechaCreacion" />}
        value={valor != null ? moment(valor).format('YYYY-MM-DD') : null   }
        id={`AuditoriaFormularioCampoFechaCreacion-${valor}`}
    />
);

export default CampoFechaCreacion;
